import React from "react";

import { useDispatch, useSelector } from "react-redux";

import AlertInline from "@src/sharedComponents/AlertInline/AlertInline";
import LinkButton from "@src/sharedComponents/LinkButton/LinkButton";
import { State } from "@src/store";

import styles from "./AlertInlineGlobal.module.css";

const AlertInlineGlobal: React.FC = () => {
  const globalAlert = useSelector(
    (state: State) => state.main_Reducer.global_alert
  );

  const dispatch = useDispatch();

  const handleOnClick = () => {
    dispatch({ type: "CLEAR_GLOBAL_ALERT_DATA" });
  };

  if (globalAlert === null) {
    return null;
  }

  const { message, severity, variant, to, buttonText, showIcon } = globalAlert;

  return (
    <AlertInline
      className={styles.alert}
      message={message}
      severity={severity}
      variant={variant}
      showIcon={showIcon}
    >
      {to && buttonText && (
        <LinkButton
          to={to}
          text={buttonText}
          onClick={handleOnClick}
          size="small"
          style={{ marginLeft: "10px" }}
        />
      )}
    </AlertInline>
  );
};

export default AlertInlineGlobal;
